import { ApplicationState } from '@/store';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { getActiveStageTab } from '../helpers';

export const useGetActiveTab = (defaultTab: string, queryKey: string) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const headerTab = useSelector(({ ui }: ApplicationState) => ui.headerTab);
  const activeTab = getActiveStageTab(params, headerTab, defaultTab, queryKey);
  return activeTab;
};
